var _path;
import * as React from "react";
function SvgCollins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7,2 H 17 V 24 H 7 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollins);
export default __webpack_public_path__ + "static/media/Collins.a260e4646724ef7887a813f87d7c6086.svg";
export { ForwardRef as ReactComponent };